<template>
  <div id="connectRef" class="content" v-show="connectVisible">
    <div>
      <div class="title-box">
        <el-button type="default" size="small" @click="pageClose()">返回</el-button>
        <span>{{ '查看全部题目关联逻辑' }}</span>
      </div>
      <!-- <div class="add-item">
        <i class="el-icon-plus"></i>
        <span  @click="addBranch()"> 新增分支条件</span>
      </div> -->
      <div>
        <el-card
         class="box-card" v-for="(o,d) in branchList" :key="d">
          <div slot="header" class="header"  @click="expandSwicthHandler(o)">
            
            <i v-if="o.isExpand" class="el-icon-caret-bottom"></i>
            <i v-if="!o.isExpand" class="el-icon-caret-right"></i>
            
            <span> {{'关联逻辑 ' }}{{ d+1 }}</span>
            <!-- <div >
              <el-button type="default" size="small" @click="addBranch(o)">编辑分支条件</el-button>
              <el-button type="default" size="small" >删除分支条件</el-button>
            </div> -->
          </div>
          <div v-show="o.isExpand" class="card-body-content">
            <div  class="card-box">
              <div v-for="(i,d) in o.rule" :key="d">
                <span v-if="d>0" style="color:red">{{o.logicSymbol=='1'?'并且':'或者'}}</span>
                <!-- {{ '当题目【' + i +'】选择'+ i +'时,'}} -->
                {{ getTips(i)  }}
              </div>
            </div>
            <div class="card-content">
              <span>则显示：</span>
              <div v-for="(j,jd) in o.subjectNos" :key="jd">
              {{ getTitle(j,jd)  }}
              </div>
            </div>
            
            
          </div>
        
        </el-card>
      </div>
      
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
export default {
  props: {
    branchList: {//所有逻辑
      type: Array,
      default: [],
    },
    subjectList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      connectVisible: false,
      options: [],
      value: '',
      tjList:[],//条件
      addBranchVisible:false,//新增分支弹窗
      // isExpand:false,
      contentHeight:''
    };
  },
  computed: {
  
    
  },
  watch: {
    connectVisible(val){
      if(val){
        // this.getOption()
        this.branchList.forEach(e => {
          e.isExpand=true
        });
        console.log('watch',this.branchList);
        
        const connectRef = document.getElementById('connectRef');
        connectRef.scrollTo({
            top: 0,
            behavior: 'smooth' // 平滑滚动
          });
      }
    }
  },

  created() {
    
  },
  methods:{
    getTips(item){
     
        let arr=this.getXxOptions(item)
        // arr.filter(o=>o.value==item.subjectOption)||
        // let obj=arr.filter((o,d)=>d==item.subjectOption)
        let optionTexts = item.subjectOption.map(optionIndex => {
            let optionObj = arr[parseInt(optionIndex)];
            return optionObj? optionObj.text : '';
        }).filter(text => text!== '');

        let optionTextStr = optionTexts.join(' 且 ');
        let idx=this.subjectList.findIndex(i=>i.subjectNo==item.subjectNo)
        let subject=cloneDeep(this.subjectList[idx])
        // console.log('hhhhh',obj);
        const str = `当题目【${idx+1}.${subject.subjectTitle}】选择【${optionTextStr}】时，`;
          
      return str
    },
    getTitle(j,d){
      // console.log('getTitle',j,d);
      let idx=this.subjectList.findIndex(i=>i.subjectNo==j)
      let subject=cloneDeep(this.subjectList[idx])
      const str = `${idx+1}、${subject.subjectTitle}`
      return str
    },
    getXxOptions(b){
      let obj=this.subjectList.filter(item => item.subjectNo === b.subjectNo)
      let arr=obj.length>0?obj[0].selectItems:[]
      return arr
    },
    dialogSure(){
      this.addBranchVisible=false
    },
    expandSwicthHandler(o) {
      
      o.isExpand = !o.isExpand;
      this.$forceUpdate()
      console.log('o',o);
      
    },
    pageClose() {
      this.connectVisible = false;
      this.$emit('pageClose', this.connectVisible);
    },
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  background-color: #fff;
  // padding-bottom: 60px;
  .header{
    text-align: left;
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
    line-height: 21px;
    font-weight: 600;
  }
  /deep/ .el-card__body{
    text-align: left;
    padding:0
    // padding: 10px 20px;
  }
  /deep/ .el-card__header{
    background-color: #fafafa;
    padding: 13px 10px;
  }
  .box-card{
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 10px;
    i{
      width: 24px;
      text-align: center;
    }
  }
  .card-body-content{
    padding: 10px 20px;
  }
  .card-box{
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
    line-height: 21px;
    font-weight: 600;
  }
  .card-content{
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
    line-height: 21px;
    font-weight: 400;
    margin-top: 10px;
  }
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
    .approve-btn{
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
    .approve-tag{
      font-size: 12px;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
  }
  .title-btn{
    text-align: left;
    padding: 0 16px 10px;
  }
  .add-item {
    height: 80px;
    width: 100%;
    background-color: #FAFAFA;
    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 2px;
    font-size: 14px;
    text-align: center;
    line-height: 80px;
    color: #999999;
  }

  .add-item:hover {
    background: #EBF6F7;
    border: 1px solid rgba(79, 161, 164, 1);
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 12px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
/deep/ .el-input__inner{
  height:40px;
  line-height:36px
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>
<style scoped>
.content-main-box {
  height: 100%;
  max-height: 300px;
}
.el-table .el-table__cell {
  padding: 0px;
}
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
.mt20 .el-form-item__content {
  width: 830px;
}

.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
</style>
